const texteNullable = (valeur) => {
  const texte = String(valeur ?? '').trim();
  return texte || null;
};

export function normaliserMagasinClub(magasin = {}, clubId) {
  return {
    ...(magasin.id ? { id: magasin.id } : {}),
    club_id: clubId,
    nom: String(magasin.nom || '').trim(),
    taux: Number(magasin.taux) || 0,
    adresse: texteNullable(magasin.adresse),
    code_postal: texteNullable(magasin.code_postal),
    ville: texteNullable(magasin.ville),
    telephone: texteNullable(magasin.telephone),
    email: texteNullable(magasin.email),
    actif: magasin.actif !== false,
  };
}

export function preparerSynchronisationMagasins(clubId, magasins = [], idsSupprimes = []) {
  const normalises = magasins.map((magasin) => normaliserMagasinClub(magasin, clubId));
  return {
    existants: normalises.filter((magasin) => magasin.id),
    nouveaux: normalises.filter((magasin) => !magasin.id),
    idsSupprimes: [...new Set(idsSupprimes.filter(Boolean).map(String))],
  };
}

export async function sauvegarderMagasinsClub(clientSupabase, clubId, magasins = [], idsSupprimes = []) {
  const plan = preparerSynchronisationMagasins(clubId, magasins, idsSupprimes);
  for (const magasin of plan.existants) {
    const { id, ...modifications } = magasin;
    const { error } = await clientSupabase.from('magasins_club').update(modifications).eq('id', id).eq('club_id', clubId);
    if (error) throw error;
  }
  if (plan.nouveaux.length) {
    const { error } = await clientSupabase.from('magasins_club').insert(plan.nouveaux);
    if (error) throw error;
  }
  for (const id of plan.idsSupprimes) {
    const { error } = await clientSupabase.from('magasins_club').delete().eq('id', id).eq('club_id', clubId);
    if (error) throw error;
  }
  return plan;
}
